import styled from 'styled-components'

interface ICreateBeneficiaryFormEmbeddedFormStyledProps {
  mountElementId: string
}

export const CreateBeneficiaryFormEmbeddedFormStyled = styled.div<ICreateBeneficiaryFormEmbeddedFormStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  flex-grow: 1;

  #${(props) => props.mountElementId} {
    display: flex;
    flex-grow: 1;
  }
`
